import Result from '../containers/Result'

export default Result
